/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">
            <tab :list="tablist" :active.sync="active"></tab>
    </titleInfo>
    <div class="itemBodyMain">
      <echarts :active="active"></echarts>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import echarts from "@/components/home/item3/echarts";
import tab from "../item3/components/tab";
export default {
  name: "index",
  components: {titleInfo, echarts,tab},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      active: 2,
      tablist: [ {
        name: '近7天',
        id: 1,
      }, {
        name: '近30天',
        id: 2
      }]
    }
  },
  watch: {
    active(){
      console.log(this.active)
    }
  },
  mounted() {

  },
  methods: {
    getHide() {
      this.$emit('getHide', 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);
  }
}
</style>
